import styled from 'styled-components';

export const StyledSplashContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  max-width: 750px;
  margin: 0 auto;
  text-align: center;
`;

export const StyledTabViewContainer = styled.div`
  padding-top: 2rem;
`;

export const StyledSpinnerContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.5);
`;

export const Subtext = styled.div`
  font-size: 1.8rem;
  margin: 4rem 0;
`;

export const StyledEmailsTimeFrame = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  margin-bottom: 20px;
`;
